
import TableList from "@components/templates/tablelist";
import { HttpDestoryOrderList, HttpGetAllOrg } from "@/service/destory";
import { mapState, mapGetters } from "vuex";
import compAdd from './add'
import comIndex from './update'
import compSubmit from './../submit'
import mixin from './mixin'
export default {
    mixins: [TableList, mixin],
    components: {
        compAdd,
        comIndex
    },
    data() {
        return {
            // totals: 0,
            isMixin: true,
            Tools: { show: true },
            Tabs: { show: true },
            formData: {
                search: {
                    // 'IN_orderStatus':null,
                }
            },
            Searchs: {
                show: true,
                labelWidth: 90,
            },
            datename: '',
            datetime: '',
            Plugins: { show: true },
            initData: '',
            addressCodeList: [],
            // contextList: []
        };
    },
    created() {
        // HttpGetAllOrg({
        //     page: 1,
        //     rows: 1000,
        //     'search[EQ_serviceType]': 1
        // }).then(res => {
        //     this.contextList = res.data.content.map(item => {
        //         return {
        //             label: item.name,
        //             value: item.id
        //         }
        //     })
        //     this.loading2 = false
        // }, err => {
        //     this.$VMessage.error(err.message)
        // })
    },
    methods: {
        ajaxRequest: HttpDestoryOrderList,
        interceptRequest: (params) => {
            let data = params
            data.warehouseId = data.search.warehouseId
            delete data.search.warehouseId
            return {
                ...data
            }
        },
        handleOperates(params = "", type) {
            switch (type) {
                case "add":
                    // this.$router.push({
                    //     name: 'destoryUpdate',
                    //     params: { type: "add" },
                    //     // query: { id: params },
                    // });
                    this.operate = {
                        title: '添加',
                        show: true,
                        width: 800,
                        component: "compAdd",
                        activeid: params,
                        querytype: 'query',
                        showFooter: false
                    }
                    break;
                case "edit":
                    // this.$router.push({
                    //     name: 'destoryOrderUpdate',
                    //     params: { type: "edit" },
                    //     query: { id: params },
                    // });
                    var url = this.$router.resolve({
                        name: "destoryOrderUpdate",
                        params: { type: "edit" },
                        query: { id: params },
                    });
                    window.open(url.href, '_blank');
                    break;
                case "query":
                    this.operate = {
                        title: '查看',
                        show: true,
                        width: 1200,
                        component: "comIndex",
                        id: params,
                        type: 'query',
                        showFooter: false
                    }
                    break;
                case "queryBlank":
                    var url = this.$router.resolve({
                        name: "destoryOrderUpdate",
                        params: { type: "query" },
                        query: { id: params },
                    });
                    window.open(url.href, '_blank');
                    break;
                case "submitbox":
                    this.operate = {
                        show: true,
                        // alert: "error",
                        title: "确认",
                        width: 460,
                        id: params,
                        otherParams: {
                            noRequired: true
                        },
                        type: 5,
                        isOrder: 1,
                        component: compSubmit,
                        showFooter: false,
                    };
                    break;
                case "cancel":
                    this.operate = {
                        show: true,
                        // alert: "error",
                        title: "取消",
                        otherParams: {
                            noRequired: true
                        },
                        width: 460,
                        id: params,
                        type: 10,
                        isOrder: 1,
                        component: compSubmit,
                        showFooter: false,
                    };
                    break;
                case 'export':
                    let searchData = {
                        warehouseId: this.formData.warehouseId
                    }
                    Object.keys(this.formData.search).map(item => {
                        searchData[`search[${item}]`] = this.formData.search[item]
                    })
                    this.handleWebfs(process.env.VUE_APP_APIURL_FBB + "/api/v2/destroyOrder/export",
                        searchData
                        , {
                            executor: 'request',
                            download: true,
                        }).catch(err => {
                            this.$VMessage.error(err.message);
                        })
                    break
            }
        },
        getOperateNodeMap(row) {
            const { id, status } = row
            return [
                {
                    label: '查看',
                    show: true,
                    params: id,
                    operate: 'query'
                },
                {
                    label: '编辑',
                    show: status === 0,
                    params: id,
                    operate: 'edit'
                },
                {
                    label: '确认',
                    show: status === 0,
                    params: id,
                    operate: 'submitbox'
                }, {
                    label: '取消',
                    show: status === 0,
                    params: id,
                    operate: 'cancel'
                }]
        },
    },
    computed: {
        ...mapGetters('dictionary', ['getCusproductList', 'getBillcusWareList','getUserManageWarehouseList', 'getSelfmanageorgList']),
        ToolsData() {
            return [
                {
                    name: "添加",
                    operate: "add",
                    theme: "primary",
                },
                {
                    name: '导出',
                    operate: 'export',
                    theme: 'primary'
                },
            ]
        },
        SearchsData() {
            let widthStyle = 'width: 220px;'
            return [
                {
                    label: "销毁单号",
                    tag: 'vInput',
                    key: 'EQ_destroyOrderNo',
                    show: true,
                    style: 'width: 120px;'
                },
                {
                    label: "来源单号",
                    tag: 'vInput',
                    key: 'EQ_sourceNo',
                    show: true,
                    style: 'width: 120px;'
                }, 
                {
                    label: '销毁计划单号',
                    tag: 'vInput',
                    key: 'EQ_destroyPlanOrderNo',
                    show: true,
                    style: 'width: 120px;'
                },
                {
                    label: "状态",
                    tag: 'Select',
                    key: 'IN_status',
                    options: this.statusList,
                    props: {
                        filterable: true,
                        multiple: true
                    },
                    style: widthStyle
                },
                {
                    label: "仓库",
                    tag: 'Select',
                    key: 'IN_orgWarehouseCode',
                    options: this.getUserManageWarehouseList,
                    props: {
                        filterable: true,
                        multiple: true
                    },
                    style: widthStyle
                },
                {
                    label: this.$t('global.common.line', { defaultValue: '项目' }),
                    key: 'EQ_lineId',
                    tag: 'Select',
                    options: this.getCusproductList,
                    props: {
                        filterable: true,
                    },
                    style: widthStyle
                },
                {
                    label: '客户',
                    tag: 'Select',
                    key: 'IN_organizationId',
                    options: this.getSelfmanageorgList,
                    props: {
                        filterable: true,
                        multiple: true
                    },
                    style: widthStyle
                },
                {
                    label: "创建日期",
                    tag: 'vDatepicker',
                    key: 'BT_createdAt',
                    // default:this.initData,
                    props:{
                        options:this.options,
                        format:'yyyy-mm-dd ~ yyyy-mm-dd',
                        confirm:false,
                    },
                    style: widthStyle
                },
            ]
        },
        columns() {
            return [
                {
                    title: '操作',
                    width: 70,
                    render: this.getOperateNodes,
                },
                {
                    title: '客户',
                    key: 'organizationId',
                    render: (h, { row }) => {
                        let orgName = this.getSelfmanageorgList.filter(item => {
                            return item.value === row.organizationId
                        })[0] || {}
                        return orgName.label
                    }
                }, 
                {
                    title: '销毁单号/来源单号',
                    sortable: true,
                    key: 'destroyOrderNo',
                    render: (h, { row }) => {
                        return <div>
                            <div>
                                <a onClick={this.handleOperates.bind(this, row.id, 'query')}>{row.destroyOrderNo || '--'}</a>
                                <a onClick={this.handleOperates.bind(this, row.id, 'queryBlank')}><vIcon class="margin-left-10 font-14" type="ios-browsers-outline" /></a>
                            </div>
                            <div>{row.sourceNo || '--'}</div>
                        </div>
                    }
                }, 
                
                {
                    title: '销毁计划单号',
                    key: 'destroyPlanOrderNo'
                },
                {
                    title: '状态',
                    key: 'status',
                    render: (h, { row }) => {
                        let label = this.statusList.filter(item => {
                            return row.status === item.value
                        })[0] || {}
                        return (
                            <div>
                                <div class={label.theme}>{label.label}</div>
                            </div>
                        )
                    }
                },
                {
                    title: '仓库',
                    key: 'orgWarehouseName',
                    render: (h, { row }) => {
                        return (
                            <div>{row.orgWarehouseName}({row.orgWarehouseCode})</div>
                        )
                    }
                },
                {
                    title: '项目',
                    key: 'lineName',
                    render: (h, { row }) => {
                        return (
                            <div>{row.lineName || '--'}</div>
                        )
                    }
                },
                {
                    title: '更新时间',
                    key: 'updatedAt',
                },
            ];
        },

    },

};
